import { BehaviorSubject } from "rxjs";

export const ObjectiveSubject = new BehaviorSubject([]);
